import { ReactElement } from "react";
import Layout from "../../components/layout";
import MerchantTransactionList from "../../components/Shops/transactions";

const MerchantTransactionPage = (): ReactElement => {
  return (
    <Layout>
      <MerchantTransactionList />
    </Layout>
  );
};

export default MerchantTransactionPage;
